import { IContextualMenuItem } from "@fluentui/react";
import { useExploreDispatch, useExploreSelector } from "pages/Explore/state/hooks";

import {
  selectCurrentCollection,
  setCollectionQuery,
} from "pages/Explore/state/collectionSlice";
import { ICollection, ISortDir } from "pages/Explore/types";

export const useSortMenuItem = (): IContextualMenuItem => {
  const dispatch = useExploreDispatch();
  const { query } = useExploreSelector(selectCurrentCollection);
  const { previewMode } = useExploreSelector(s => s.detail);
  
  const clickHandler = (dir: ISortDir) => {
    return (
      e:
        | React.MouseEvent<HTMLElement, MouseEvent>
        | React.KeyboardEvent<HTMLElement>
        | undefined
    ) => {
      const updatedCollection: ICollection = {
        ...query,
        sortby: dir,
      };
      dispatch(setCollectionQuery(updatedCollection));
      e?.preventDefault();
    };
  };

  return {
    key: "sortby",
    text: "Sort order",
    iconProps: { iconName: "Sort" },
    disabled: previewMode.enabled,
    "data-cy": "sortby",
    subMenuProps: {
      items: [
        {
          key: "sortby-date-desc",
          text: "Date descending",
          title: "Show newest results first",
          "data-cy": "sortby-desc",
          iconProps: { iconName: "SortDown" },
          canCheck: true,
          checked: !query.sortby || query.sortby === "desc",
         onClick: clickHandler("desc"),
        },
        {
          key: "sortby-date-asc",
          text: "Date ascending",
          title: "Show oldest results first",
          iconProps: { iconName: "SortUp" },
          canCheck: true,
          checked: query.sortby === "asc",
         onClick: clickHandler("asc"),
        },
      ],
    },
  };
};